import React from 'react';
import {
  Box,
  Container
} from '@chakra-ui/react';


/**
 * TODO: Currently there is no content.
 * To be filled in at a later time
 */
import HeadingWithText from '../../components/sections/headingwithtext'

export default function PranaTabPanel() {
  return (
    <Box>
      <Container maxW='6xl' my={14} className='flow'>
        <HeadingWithText
          title="COMING SOON..."
        ></HeadingWithText>
      </Container>
    </Box>
  );
}
